import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";

export var CreateCost = gql`
  mutation manualApplication($organizationId: UUID!, $startDate: DateTime!, $endDate: DateTime!, $application: ApplicationInput!, $tenants: [ApplicantsInput!]! ) {
    manualApplication(organizationId: $organizationId, startDate: $startDate, endDate: $endDate, application: $application, tenants: $tenants) {
     id
    }
  }
`;



export function apiAddManualApplication(organizationId, startDate, endDate, application, tenants, consentGranted) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");

        // Add sms_consent_granted to the application object
        const applicationWithConsent = {
            ...application,
            sms_consent_granted: consentGranted
        };

        client
            .mutate({
                mutation: CreateCost,
                variables: {organizationId, startDate, endDate, application: applicationWithConsent, tenants},
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.manualApplication);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to add manual application");
                reject(err); // R
            })
    });
}
